"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: 1,
  question: "How Much Does Wedding Videography Cost In Australia?",
  answer: "Most couples in Australia spend between $2,000 and $7,000 on professional wedding videography, which is comparable to the cost of wedding photography. This range reflects the investment in an experienced videographer who brings reliable equipment, thoughtful storytelling, and a calm presence, rather than a DIY or part‑time approach."
}, {
  id: 2,
  question: "What is the realistic budget for a wedding in Australia?",
  answer: "A realistic Australian wedding budget varies depending on location, guest numbers, and priorities, but many couples spend between $36,000 and $41,000. It is common for final costs to rise beyond the initial plan as expenses like styling, attire, and entertainment are added. Guest numbers have the biggest impact on catering, while venue choice and suppliers also shape the overall budget. Setting a comfortable range early, choosing a few clear priorities, and allowing a buffer for unexpected extras can help couples plan with confidence and avoid unnecessary stress."
}, {
  id: 3,
  question: "How to save on wedding costs",
  answer: "Being selective with your guest list is one of the simplest ways to reduce wedding costs. Every extra guest increases catering, drinks, seating, and venue size. A smaller guest list keeps the day more personal and frees up budget for the things that matter most, while reducing stress and pressure overall."
}, {
  id: 4,
  question: "What is the most expensive part of a wedding?",
  answer: "While venue, catering, and photography are usually the largest wedding expenses, smaller costs often have the biggest impact on the final budget. Transportation, accommodation, signage, styling hire, and guest favors can quietly add up if they are not planned for early. These extras are easy to overlook because they feel minor on their own, but together they can shift a budget significantly. Being aware of these hidden costs from the beginning allows couples to make calmer decisions, prioritise what truly matters, and avoid last minute stress as the wedding day approaches."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-3xl">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground text-center mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground/70 text-center text-base md:text-lg mb-12">
            Find answers to common questions about our services and process
          </p>

          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => <AccordionItem key={faq.id} value={`item-${faq.id}`} data-index={i} className={`bg-muted rounded-md border-border px-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <AccordionTrigger className="text-foreground hover:text-primary transition-colors duration-[var(--duration-fast)] py-5 text-base md:text-lg font-semibold">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-foreground/80 text-sm md:text-base leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}